import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ILocationIconProps extends ISvgIconProps {

}

export class LocationIcon extends React.Component<ILocationIconProps> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 60 60">
                <path d="M62.507,34.33c5.529-8.676,4.834-7.594,4.993-7.82a16.62,16.62,0,0,0,3.077-9.664,16.744,16.744,0,1,0-30.324,9.787l4.9,7.7C39.915,35.136,31,37.537,31,42.825c0,1.928,1.258,4.675,7.252,6.815a48.046,48.046,0,0,0,15.581,2.318c10.963,0,22.833-3.092,22.833-9.133C76.667,37.536,67.762,35.137,62.507,34.33ZM42.8,24.959q-.025-.039-.052-.077a13.7,13.7,0,1,1,22.287-.154c-.147.193.618-1-11.2,17.548ZM53.833,48.914c-11.974,0-19.789-3.52-19.789-6.089,0-1.727,4.015-4.566,12.913-5.673l5.592,8.774a1.522,1.522,0,0,0,2.567,0l5.592-8.774c8.9,1.107,12.914,3.946,12.914,5.673C73.622,45.372,65.878,48.914,53.833,48.914Z"
                    transform="translate(-24 4)" fill="currentColor"
                />
                <path d="M188.611,91a7.611,7.611,0,1,0,7.611,7.611A7.62,7.62,0,0,0,188.611,91Zm0,12.178a4.567,4.567,0,1,1,4.567-4.567A4.572,4.572,0,0,1,188.611,103.178Z"
                    transform="translate(-158.778 -77.765)" fill="currentColor"
                />
            </SvgIcon>
        );
    }
}
